import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./Calculator.css";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Tooltip,
  tooltipClasses,
  styled,
  ClickAwayListener,
} from "@mui/material";

import question from "../../../../../Assets/Images/question.png";
import LoanDetails from "./LoanDetails/LoanDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

import { amortizationHeader } from "./totalingData";

const Calculator = () => {
  const [showMore, setShowMore] = useState(false);
  const [originationTotal, setOriginationTotal] = useState(false);
  const [processingOption, setProcessingOption] = useState("");
  const [emi, setEmi] = useState("");
  const [totalPrincipal, setTotalPrincipal] = useState("");
  const [interestPayment, setInterestPayment] = useState("");
  const [loanPayment, setLoanPayment] = useState("");
  const [processingFee, setProcessingFee] = useState("");
  const [costOfLoan, setCostOfLoan] = useState("");
  const [closureDate, setClosureDate] = useState("");
  const [apr, setApr] = useState("");
  const [amortization, setAmortization] = useState([]);

  const [openLoanPaymentTooltip, setOpenLoanPaymentTooltip] = useState(false);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const handleLoanPaymentTooltipClose = () => {
    setOpenLoanPaymentTooltip(false);
  };

  const handleLoanPaymentTooltipOpen = () => {
    setOpenLoanPaymentTooltip(true);
  };

  const handleShowAmortization = () => {
    setShowMore((prev) => !prev);
  };

  const handleOrigination = (data) => {
    setOriginationTotal(data);
  };

  const handleProcessingOption = (data) => {
    setProcessingOption(data);
  };

  const handleCalculatorData = (data) => {
    setEmi(data.emi);
    setTotalPrincipal(data.totalPrincipal);
    setInterestPayment(data.totalInterest);
    setLoanPayment(data.totalLoanPayments);
    setClosureDate(data.loanClosureDate);
    setProcessingFee(data.processingFeeAmount);
    setCostOfLoan(data.totalCost);
    setApr(data.apr);
    setAmortization(data.amortizationSchedule);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFont("helvetica", "bold");
    doc.text("Amortization Schedule", 14, 10);

    autoTable(doc, {
      startY: 20,
      head: [amortizationHeader.map((item) => item.head)],
      body: amortization.map((row) => [
        row.date,
        row.principal,
        row.interest,
        row.emi,
        row.balance,
      ]),
      theme: "grid",
    });

    doc.save("amortization_schedule.pdf");
  };

  return (
    <>
      <div
        id="calculator--box"
        className="calculator_box d-flex flex-column flex-md-row align-items-md-start gap-4 w-100"
      >
        <aside id="loan_details">
          <LoanDetails
            onCheck={handleOrigination}
            onSelect={handleProcessingOption}
            onData={handleCalculatorData}
          />
        </aside>
        <section id="loan_estimate" className="">
          <div className="loan_estimate__container rounded">
            <div className="p-3">
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontFamily: "'Archivo', sans-serif",
                }}
                className="archivo fw-bold"
              >
                Your loan estimate
              </Typography>
              <div className="calculator_box w-100  gap-3 mt-3">
                <div
                  id="monthly-payment"
                  className="d-flex flex-column text-wrap align-items-start justify-content-start"
                >
                  <Typography
                    sx={{
                      fontSize: "19.9267px",
                      color: "#59266D",
                      letterSpacing: "normal",
                      fontFamily: "'Archivo', sans-serif",
                      textAlign: "start",
                    }}
                    className="mt-1"
                  >
                    Monthly payment
                  </Typography>
                  <p className="monthly_payment text-start m-0 text-break archivo">
                    {/* {totalingData[0].monthlyPayment} */}
                    {emi}
                  </p>
                </div>
                <div className="totaling">
                  <div className="">
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Total Principal
                      </p>
                      <p className="amount text-break archivo m-0">
                        {/* {totalingData[0].principal} */}
                        {totalPrincipal}
                      </p>
                    </div>
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Total interest payments
                      </p>
                      <p className="amount text-break archivo m-0">
                        {/* {totalingData[0].interestPayment} */}
                        {interestPayment}
                      </p>
                    </div>
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <div className="totals d-flex flex-row align-items-center gap-1  m-0">
                        <p className=" archivo m-0 ">Total loan payments</p>
                        <div id="advertiser__discloser">
                          <ClickAwayListener
                            onClickAway={handleLoanPaymentTooltipClose}
                          >
                            <div className="w-auto">
                              <LightTooltip
                                arrow
                                open={openLoanPaymentTooltip}
                                title={
                                  <p
                                    style={{ fontSize: 16, color: "#8A8A8A" }}
                                    className="archivo m-0 p-1"
                                  >
                                    The total loan payments are the sum of the
                                    principal and total interest paid
                                  </p>
                                }
                              >
                                <div>
                                  <span>
                                    <img
                                      src={question}
                                      alt="icon"
                                      style={{
                                        width: 16,
                                        height: 16,
                                        cursor: "pointer",
                                      }}
                                      onClick={handleLoanPaymentTooltipOpen}
                                    />
                                  </span>
                                </div>
                              </LightTooltip>
                            </div>
                          </ClickAwayListener>
                        </div>
                      </div>
                      <p className="amount text-break archivo m-0">
                        {loanPayment}
                      </p>
                    </div>

                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Payoff date
                      </p>
                      <p className="amount text-break archivo m-0">
                        {closureDate}
                      </p>
                    </div>

                    <div
                      className={`${
                        originationTotal ? "d-block" : "d-none"
                      } mt-4 pt-2`}
                    >
                      <div className="total__labels d-flex justify-content-between align-items-start">
                        <p className="totals text-break archivo m-0">
                          Processing Fee
                        </p>
                        <p className="amount text-break archivo m-0">
                          {/* {totalingData[0].originationFee} */}
                          {processingFee}
                        </p>
                      </div>
                      <div
                        className={`total__labels ${
                          processingOption === "fixedAmount"
                            ? "d-none"
                            : "d-flex"
                        }  justify-content-between align-items-start`}
                      >
                        <p className="totals text-break archivo m-0">
                          Cost Of Loan
                        </p>
                        <p className="amount text-break archivo m-0">
                          {/* {totalingData[0].costOfLoan} */}
                          {costOfLoan}
                        </p>
                      </div>
                      <div className="total__labels d-flex justify-content-between align-items-start">
                        <p className="totals text-break archivo m-0">APR</p>
                        <p className="amount text-break archivo m-0">
                          {/* {totalingData[0].apr} */}
                          {apr}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Button
                fullWidth
                sx={{
                  fontSize: 16,
                  lineHeight: "24px",
                  fontFamily: "'Archivo', sans-serif",
                  textTransform: "none",
                  padding: "15px 20px",
                }}
                onClick={handleShowAmortization}
                className="archivo d-flex justify-content-between"
              >
                <p className="m-0">
                  {showMore
                    ? "Hide amortization schedule"
                    : "Show amortization schedule"}{" "}
                </p>
                <p className="m-0">
                  <FontAwesomeIcon
                    icon={showMore ? faChevronUp : faChevronDown}
                  />
                </p>
              </Button>
              <div
                className={`amortization_table ${
                  showMore ? "d-block" : "d-none"
                } no-scrollbar pb-0 mb-0`}
              >
                <TableContainer component={Paper}>
                  <Table
                  // sx={{
                  //   boxShadow: "inset 0px 0px 5px 3px #cacaca",
                  // }}
                  >
                    <TableHead>
                      <TableRow sx={{ verticalAlign: "baseline" }}>
                        {amortizationHeader &&
                          amortizationHeader.map((item, index) => (
                            <TableCell
                              sx={{
                                fontSize: 13,
                                lineHeight: "20px",
                                fontFamily: "'Archivo', sans-serif",
                              }}
                              className="archivo fw-bold"
                            >
                              {item.head}
                            </TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {amortization &&
                        amortization.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell
                              sx={{
                                fontSize: 13,
                                lineHeight: "20px",
                                fontFamily: "'Archivo', sans-serif",
                              }}
                            >
                              {item.date}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: 13,
                                lineHeight: "20px",
                                fontFamily: "'Archivo', sans-serif",
                              }}
                            >
                              {item.principal}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: 13,
                                lineHeight: "20px",
                                fontFamily: "'Archivo', sans-serif",
                              }}
                            >
                              {item.interest}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: 13,
                                lineHeight: "20px",
                                fontFamily: "'Archivo', sans-serif",
                              }}
                            >
                              {item.emi}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: 13,
                                lineHeight: "20px",
                                fontFamily: "'Archivo', sans-serif",
                              }}
                            >
                              {item.balance}
                            </TableCell>
                          </TableRow>
                        ))}
                      <TableRow>
                        <TableCell colSpan={5}>
                          <Button
                            variant="contained"
                            onClick={downloadPDF}
                            fullWidth
                          >
                            Download PDF
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Calculator;
